<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="All loans" name="first"></el-tab-pane>
			<el-tab-pane label="New loan" name="second"></el-tab-pane>
			<!-- <el-tab-pane label="Loan calculator" name="third"></el-tab-pane> -->
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>Search by client, loan ID</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-20">
					<md-field>
						<label>Loan Type</label>
						<md-select placeholder="Loan Type (All)" v-model="search.type">
							<md-option value="">All</md-option>
							<md-option value="mpip">Monthly Principal + Interest</md-option>
							<md-option value="mip">Monthly Intereset</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-20">
					<md-field>
						<label>Status</label>
						<md-select placeholder="Status (All)" v-model="search.status">
							<md-option value="">All</md-option>
							<md-option value="act">Active</md-option>
							<md-option value="fin">Finished</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-size-20">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">Search
					</md-button>
				</div>
			</div>
			<md-table v-if="loanList.length > 0">
				<md-table-row>
					<md-table-head>N.O</md-table-head>
					<md-table-head>Loan Date</md-table-head>
					<md-table-head>Loan ID</md-table-head>
					<md-table-head>Loan Amount</md-table-head>
					<md-table-head>Client</md-table-head>
					<md-table-head>Next Payment</md-table-head>
					<md-table-head>Status</md-table-head>
					<md-table-head>Action</md-table-head>
				</md-table-row>

				<md-table-row v-for="(loan, index) in loanList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>{{ config.datelify(loan.start_date) }}</md-table-cell>
					<md-table-cell>{{ loan.hash_id }}</md-table-cell>
					<md-table-cell>{{ config.moneylify(loan.amount) }}</md-table-cell>
					<md-table-cell><b>ID: {{loan.client_hash_id}}</b> ({{loan.name}})</md-table-cell>
					<md-table-cell>
						<span v-if="loan.total_paid == loan.term || loan.status == 'fin'" class="active">Not Available</span>
						<span class="late"
							v-else-if="String(loan.next_payment).length >0 && config.timelify(loan.next_payment) == 'Late'">{{config.datelify(loan.next_payment)}}</span>
						<span class="active"
							v-else-if="String(loan.next_payment).length >0">{{config.datelify(loan.next_payment)}}
							({{config.timelify(loan.next_payment)}})</span>
					</md-table-cell>
					<md-table-cell>
						<span class="active" v-if="loan.status == 'act'">{{config.getStatus(loan.status)}}</span>
						<span class="late" v-if="loan.status == 'fin'">{{config.getStatus(loan.status)}}</span>
					</md-table-cell>
					<md-table-cell>
						<router-link :to="'/loans/detail/' + loan.hash_id">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">View loan information</md-tooltip>
							</md-button>
						</router-link>
						<md-button class="md-just-icon md-simple md-danger" @click="showDeleteAction(loan.hash_id)">
							<md-icon>delete</md-icon>
							<md-tooltip md-direction="top">Delete this loan</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>
			<!-- <md-card v-for="(loan, index) in loanList">
				<md-card-header data-background-color="orange">
					<h4 class="title">{{index+1}} - {{loan.hash_id}}</h4>
				</md-card-header>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-45">
							<table>
								<tr>
									<td style="width: 150px">Loan amount</td>
									<td style="width: 40px">:</td>
									<td>{{config.moneylify(loan.amount)}}</td>
								</tr>
								<tr>
									<td>Loan term</td>
									<td>:</td>
									<td>{{loan.term}} Months</td>
								</tr>
								<tr>
									<td>Interest rate</td>
									<td>:</td>
									<td>{{loan.interest_rate}}%</td>
								</tr>
								<tr>
									<td>Total interest</td>
									<td>:</td>
									<td>{{config.moneylify(loan.interest_amount)}}</td>
								</tr>
								<tr>
									<td>Loan fee</td>
									<td>:</td>
									<td>{{config.moneylify(loan.loan_fee)}}</td>
								</tr>
								<tr>
									<td>Total payment</td>
									<td>:</td>
									<td><b>{{config.moneylify(loan.total_payment)}}</b></td>
								</tr>
								<tr>
									<td>Status</td>
									<td>:</td>
									<td>
										<span class="active" v-if="loan.status == 'act'">{{config.getStatus(loan.status)}}</span>
										<span class="late" v-if="loan.status == 'fin'">{{config.getStatus(loan.status)}}</span>
									</td>
								</tr>

							</table>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-45">
							<table style="border-width: 0px;">
								<tr>
									<td>Client</td>
									<td>:</td>
									<td><b>ID: {{loan.client_hash_id}}</b> ({{loan.name}})</td>
								</tr>
								<tr>
									<td style="width: 150px">Initial payment</td>
									<td style="width:40px">:</td>
									<td>{{config.moneylify(loan.initial_payment)}}</td>
								</tr>
								<tr>
									<td>Monthly payment</td>
									<td>:</td>
									<td>{{config.moneylify(loan.monthly_payment)}}</td>
								</tr>
								<tr>
									<td>Final payment</td>
									<td>:</td>
									<td>{{config.moneylify(loan.final_payment)}}</td>
								</tr>
								<tr>
									<td>Paid EMIs</td>
									<td>:</td>
									<td>{{loan.total_paid}} / {{loan.term}}</td>
								</tr>
								<tr>
									<td>Loan period</td>
									<td>:</td>
									<td>{{config.datelify(loan.start_date)}} - {{config.datelify(loan.end_date)}}</td>
								</tr>
								<tr>
									<td>Next payment</td>
									<td>:</td>
									<td>
										<span v-if="loan.total_paid == loan.term">N/A</span>
										<span class="late"
											v-else-if="String(loan.next_payment).length >0 && config.timelify(loan.next_payment) == 'Late'">{{config.datelify(loan.next_payment)}}</span>
										<span class="active"
											v-else-if="String(loan.next_payment).length >0">{{config.datelify(loan.next_payment)}}
											({{config.timelify(loan.next_payment)}})</span>

									</td>
								</tr>
							</table>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-10">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-33 md-size-100 text-center">
									<router-link :to="'/loans/detail/' + loan.hash_id">
										<md-button class="md-just-icon md-simple md-success">
											<md-icon>visibility</md-icon>
											<md-tooltip md-direction="top">View loan information</md-tooltip>
										</md-button>
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</md-card-content>
			</md-card> -->
			<h4 class="text-center" v-if="loanList.length == 0 && loadMore == true">No loan data.</h4>
			<!-- <div class="places-buttons text-center" v-if="loadMoreCompanyButton" >
				<md-button class="md-primary" @click="getCompany(companyList.length, false)">បង្ហាញបន្ថែម</md-button>
			</div> -->
		</div>



		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>New Loan</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* required</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>Loan Type *</label>
								<md-select placeholder="Loan Type *" v-model="loan.type" @md-selected="calculateLoan()">
									<md-option value="mpip">Monthly Principal + Interest Payment</md-option>
									<md-option value="mip">Monthly Interest Payment</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Loan Term *</label>
								<md-select placeholder="Loan Term *" v-model="loan.term" @md-selected="selectLoanTerm()">
									<md-option value="1">1 Month</md-option>
									<md-option value="3">3 Months</md-option>
									<md-option value="4">4 Months</md-option>
									<md-option value="5">5 Months</md-option>
									<md-option value="6">6 Months</md-option>
									<md-option value="7">7 Months</md-option>
									<md-option value="8">8 Months</md-option>
									<md-option value="9">9 Months</md-option>
									<md-option value="10">10 Months</md-option>
									<md-option value="11">11 Months</md-option>
									<md-option value="12">12 Months</md-option>
									<md-option value="15">15 Months</md-option>
									<md-option value="18">18 Months</md-option>
									<md-option value="21">21 Months</md-option>
									<md-option value="24">24 Months</md-option>
									<md-option value="30">30 Months</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Loan Start Date</label>
								<md-input type="text" v-model="loan.start_date" style="display:none" />
								<datetime type="date" v-model="loan.start_date" auto></datetime>
							</md-field>
						</div>

						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Loan Amount *</label>
								<md-input type="number" v-model="loan.amount" @keyup="calculateLoan()"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Loan Interest *</label>
								<md-input type="number" v-model="loan.interest" @keyup="calculateLoan()"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Loan Fee *</label>
								<md-input type="number" v-model="loan.fee"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>Loan Remark</label>
								<md-input type="text" v-model="loan.note"></md-input>
							</md-field>
						</div>
						<!-- <div class="md-layout-item md-size-100 text-right">
							<md-button :class="{'md-raised': true, 'md-primary': loan.valid}" :disabled="!loan.valid" @click="">
								Preview</md-button>
						</div> -->
					</div>
					<!-- <div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<h3>Development Mode</h3>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Initial principal</label>
								<md-input type="text" v-model="loan.initial_principal"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Initial interest</label>
								<md-input type="text" v-model="loan.initial_interest"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Initial payment</label>
								<md-input type="text" v-model="loan.initial_payment"></md-input>
							</md-field>
						</div>

						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Monthly principal</label>
								<md-input type="text" v-model="loan.monthly_principal"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Monthly interest</label>
								<md-input type="text" v-model="loan.monthly_interest"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Monthly payment</label>
								<md-input type="text" v-model="loan.monthly_payment"></md-input>
							</md-field>
						</div>

						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Final principal</label>
								<md-input type="text" v-model="loan.final_principal"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Final interest</label>
								<md-input type="text" v-model="loan.final_interest"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Final payment</label>
								<md-input type="text" v-model="loan.final_payment"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Loan fee</label>
								<md-input type="text" v-model="loan.fee"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Total payment</label>
								<md-input type="text" v-model="loan.total_payment"></md-input>
							</md-field>
						</div>


					</div> -->
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>Client</h3>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-70 md-size-70">
								<md-field>
									<label>Search client by name, phone or ID</label>
									<md-input type="text" v-model="search.text" @keyup.enter="searchClient()">
									</md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-30 md-size-30">
								<md-button class="md-raised md-primary" @click="searchClient()" style="width: 100%">Search
								</md-button>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<md-table>
									<md-table-row v-for="(client, index) in search.clientList">
										<md-table-cell>
											<img src="@/assets/img/default-member.png" style="width: 34px; margin-right:5px">
											<b>ID: {{client.hash_id}}</b> ({{client.name}}, {{client.phone}})
										</md-table-cell>
										<md-table-cell class=" text-right">
											<md-button class="md-just-icon md-simple md-success" @click="addClient(client)">
												<md-icon>add</md-icon>
												<md-tooltip md-direction="top">Add client</md-tooltip>
											</md-button>
										</md-table-cell>
									</md-table-row>
								</md-table>
							</div>
						</div>
					</div>

				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>Summary</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 40%;">Client</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>

									<span v-if="String(loan.client_id).length > 0"
										style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
										<span><b>ID: {{loan.client[0].hash_id}}</b> ({{loan.client[0].name}})</span>
										<md-button class="md-just-icon md-simple md-danger" @click="removeClient()">
											<md-icon>remove</md-icon>
											<md-tooltip md-direction="top">Remove client</md-tooltip>
										</md-button>
									</span>
									<span v-else>N/A</span>

								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Loan Type</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="loan.type == 'mpip'">Monthly Principal + Interest Payment</span>
									<span v-else-if="loan.type == 'mip'">Monthly Interest Payment</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>

							<md-table-row>
								<md-table-cell>Loan Term</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(loan.term).length > 0">{{loan.term}} Months</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Loan Interest</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(loan.interest).length > 0 && loan.type == 'mpip'">{{loan.interest}}% per
										annual (p.a)</span>
									<span v-else-if="String(loan.interest).length > 0 && loan.type == 'mip'">{{loan.interest}}%
										per month (p.m)</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Loan Amount</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(loan.amount).length > 0">{{config.moneylify(loan.amount)}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Loan Interest Amount</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span
										v-if="String(loan.interest_amount).length > 0">{{config.moneylify(loan.interest_amount)}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Loan Fee</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(loan.fee).length > 0">{{config.moneylify(loan.fee)}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>

							<md-table-row>
								<md-table-cell>Initial Payment</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span
										v-if="String(loan.initial_payment).length > 0">{{config.moneylify(loan.initial_payment)}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Monthly Payment</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span
										v-if="String(loan.monthly_payment).length > 0">{{config.moneylify(loan.monthly_payment)}}
										<template v-if="loan.term > 1">x ({{loan.term - 2}} Months)</template></span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Final Payment</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span
										v-if="String(loan.final_payment).length > 0">{{config.moneylify(loan.final_payment)}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Total Payment</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(loan.total_payment).length > 0"><b>{{config.moneylify(loan.total_payment)}}
											+ {{config.moneylify(loan.fee)}} Fee</b></span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>

				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="post()">
						Create</md-button>
				</div>

			</div>
		</div>

		<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="Are you sure want to delete this loan ?"
			md-content="This loan will be deleted and can't be restored." md-confirm-text="Delete" md-cancel-text="Cancel"
			@md-cancel="onCancel" @md-confirm="onDelete" />
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
			// this.getLocation();
			// this.getSettings();
			// this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					type: "",
					text: "",
					status: ""
				},
				loan: {
					start_date: "",
					amount: "",
					interest: "",
					term: "",
					type: "",
					fee: "",
					interest_amount: "",

					initial_payment: "",
					initial_principal: "",
					initial_interest: "",

					monthly_payment: "",
					monthly_principal: "",
					monthly_interest: "",

					final_payment: "",
					final_principal: "",
					final_interest: "",

					total_payment: "",
					client_id: "",
					note: "",
					client: []
				},
				loadMore: true,
				loanList: []

			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/loan/search", {
					text: this.search.text,
					type: this.search.type,
					status: this.search.status,
					offset: more ? this.loanList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					this.loanList = data.body.data;
				})

			},
			post() {
				this.loan.start_date = (new Date(this.loan.start_date)).getTime();
				this.$http.post(this.config.api + "/admin/loan/post", {
					loan: this.loan,
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = "first";
						this.searchHandler();
					}
				})
			},
			selectLoanTerm() {
				if (String(this.loan.term).length > 0 && String(this.loan.type).length > 0) {
					switch (this.loan.term) {
						case "3":
							this.loan.interest = this.loan.type == "mpip" ? 10 : 3
							break;
						case "6":
							this.loan.interest = this.loan.type == "mpip" ? 15 : 3
							break;
						case "9":
							this.loan.interest = this.loan.type == "mpip" ? 20 : 3
							break;
						default:
							this.loan.interest = this.loan.type == "mpip" ? 25 : 3

							break;
					}

				}
				this.calculateLoan();
			},
			calculateLoan() {
				if (String(this.loan.interest).length > 0 && String(this.loan.amount).length > 0 && String(this.loan.type).length > 0 && String(this.loan.term).length > 0 && parseInt(this.loan.term) > 2) {
					if (this.loan.type == 'mpip') {
						this.loan.fee = parseFloat(this.loan.amount) * 0.01;

						let amount_interest = parseFloat(this.loan.interest) / 100 * parseInt(this.loan.term) / 12 * parseFloat(this.loan.amount)

						let total_payment = parseFloat(amount_interest) + parseFloat(this.loan.amount)

						let monthly_payment = parseInt(total_payment / parseFloat(this.loan.term));
						let monthly_interest = parseInt(amount_interest / this.loan.term);
						let monthly_principal = monthly_payment - monthly_interest;

						let initial_principal = this.loan.amount - monthly_principal * (parseFloat(this.loan.term) - 1);
						let initial_interest = amount_interest - monthly_interest * (parseFloat(this.loan.term) - 1);
						let initial_payment = initial_principal + initial_interest;

						this.loan.interest_amount = amount_interest;
						this.loan.total_payment = total_payment;

						this.loan.initial_payment = initial_payment;
						this.loan.initial_principal = initial_principal;
						this.loan.initial_interest = initial_interest;

						this.loan.monthly_payment = monthly_payment;
						this.loan.monthly_principal = monthly_principal;
						this.loan.monthly_interest = monthly_interest;

						this.loan.final_payment = monthly_payment;
						this.loan.final_principal = monthly_principal;
						this.loan.final_interest = monthly_interest;
					} else if (this.loan.type == 'mip') {
						this.loan.fee = parseFloat(this.loan.amount) * 0.01;

						let initial_principal = 0;
						let initial_interest = parseFloat(this.loan.amount) * this.loan.interest / 100;
						let initial_payment = initial_principal + initial_interest;
						console.log(initial_principal);
						console.log(initial_interest);
						console.log(initial_payment);
						let monthly_interest = initial_interest;
						let monthly_principal = initial_principal;
						let monthly_payment = initial_payment;

						let final_interest = monthly_interest;
						let final_principal = parseFloat(this.loan.amount);
						let final_payment = final_interest + final_principal;

						let amount_interest = initial_interest * parseFloat(this.loan.term);
						let total_payment = amount_interest + parseFloat(this.loan.amount);

						this.loan.interest_amount = amount_interest;
						this.loan.total_payment = total_payment;

						this.loan.initial_payment = initial_payment;
						this.loan.initial_principal = initial_principal;
						this.loan.initial_interest = initial_interest;

						this.loan.monthly_payment = monthly_payment;
						this.loan.monthly_principal = monthly_principal;
						this.loan.monthly_interest = monthly_interest;

						this.loan.final_payment = final_payment;
						this.loan.final_principal = final_principal;
						this.loan.final_interest = final_interest;

					}

				} else if (String(this.loan.interest).length > 0 && String(this.loan.amount).length > 0 && String(this.loan.type).length > 0 && String(this.loan.term).length > 0 && parseInt(this.loan.term) > 0) {
					this.loan.fee = parseFloat(this.loan.amount) * 0.01;

					let amount_interest = parseFloat(this.loan.interest) / 100 * parseInt(this.loan.term) / 12 * parseFloat(this.loan.amount);

					let total_payment = parseFloat(amount_interest) + parseFloat(this.loan.amount)

					this.loan.interest_amount = amount_interest;
					this.loan.total_payment = total_payment;

					this.loan.initial_payment = 0;
					this.loan.initial_principal = 0;
					this.loan.initial_interest = 0;

					this.loan.monthly_payment = 0;
					this.loan.monthly_principal = 0;
					this.loan.monthly_interest = 0;

					this.loan.final_payment = parseFloat(this.loan.amount) + parseFloat(amount_interest);
					this.loan.final_principal = this.loan.amount;
					this.loan.final_interest = amount_interest;

				} else {
					this.loan.interest_amount = "";
					this.loan.total_payment = "";
					this.loan.fee = "";

					this.loan.initial_payment = "";
					this.loan.initial_principal = "";
					this.loan.initial_interest = "";

					this.loan.monthly_payment = "";
					this.loan.monthly_principal = "";
					this.loan.monthly_interest = "";

					this.loan.final_payment = "";
					this.loan.final_principal = "";
					this.loan.final_interest = "";
				}
			},
			searchClient() {
				this.$http.post(this.config.api + "/admin/client/search", {
					text: this.search.text,
					gender: ""
				}).then(data => {
					this.search.text = "";
					// this.loadMoreCompanyButton = true
					this.search.clientList = data.body.data;
				})
			},
			addClient(client) {
				this.loan.client_id = client.id;
				this.loan.client.push(client);
				this.search.clientList = []
			},
			removeClient() {

				this.loan.client_id = "";
				this.loan.client = [];
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete() {
				this.$http.post(this.config.api + "/admin/loan/delete", {
					hash_id: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "This loan was deleted successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.deleteDialogActive = false
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Loans/View.vue